import client from './client';

export interface NotificationRecord {
  id: string;
  type: string;
  title: string;
  content: string;
  priority: string;
  readAt: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
}

export interface NotificationListMeta {
  currentPage: number;
  itemCount: number;
  itemsPerPage: number;
  totalItems: number;
  totalPages: number;
}

export interface NotificationListResponse {
  data: NotificationRecord[];
  meta: NotificationListMeta;
}

export interface NotificationListParams {
  page?: number;
  limit?: number;
}

const basePath = '/notifications';

const notificationsService = {
  async list(params: NotificationListParams = {}): Promise<NotificationListResponse> {
    const { data } = await client.get<NotificationListResponse>(basePath, {
      params,
    });
    return data;
  },

  async markAsRead(id: string): Promise<NotificationRecord> {
    const { data } = await client.patch<NotificationRecord>(
      `${basePath}/${id}/read`,
    );
    return data;
  },

  async markAllAsRead(): Promise<{ updated: number }> {
    const { data } = await client.post<{ updated: number }>(
      `${basePath}/mark-all-read`,
    );
    return data;
  },

  async getUnreadCount(): Promise<{ count: number }> {
    const { data } = await client.get<{ count: number }>(`${basePath}/unread`);
    return data;
  },
};

export default notificationsService;
